// Privacy.tsx
import React from 'react';

export function Privacy() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-6xl mx-auto px-6 py-8">
        <h1 className="text-3xl font-bold text-center mb-8">Privacy Policy</h1>
        
        <div className="bg-white rounded-lg shadow-sm p-6">
          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">1. Information We Collect</h2>
              <p>We collect information that you provide directly to us:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Account information (email address, password)</li>
                <li>Financial data uploaded to our platform</li>
                <li>Usage data & analytics related to your interaction with our services</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">2. How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Provide, maintain, and improve our services</li>
                <li>Process and analyze financial data</li>
                <li>Communicate with you about our services</li>
                <li>Protect against fraud, unauthorized access and misuse</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">3. Data Security</h2>
              <p>We implement appropriate security measures to protect your data:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Encryption of data in transit and at rest</li>
                <li>Regular security assessments</li>
                <li>Limited employee access to sensitive data</li>
              </ul>
              <p>However, no method of data transmission or storage is 100% secure, and we cannot guarantee absolute security.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">4. Data Retention</h2>
              <p>We retain your information:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>For as long as your account is active or as necessary to provide services</li>
                <li>In accordance with legal, regulatory, and compliance requirements</li>
              </ul>
              <p>You may request deletion of your data at any time, but certain data may be retained as required by law or for business continuity.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">5. Your Rights</h2>
              <p>You have the right to:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Access your personal information</li>
                <li>Request corrections to inaccurate data</li>
                <li>Request deletion of your data (subject to legal retention requirements)</li>
                <li>Export your data</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">6. Third-Party Services</h2>
              <p>We use third-party service providers to support our platform, including for:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Authentication and data storage</li>
                <li>Analytics and performance tracking</li>
              </ul>
              <p>These third parties process your data in accordance with their own privacy policies, and we are not responsible for their security practices.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">7. Contact Us</h2>
              <p>For privacy-related questions:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Email us at: support@provafi.com</li>
              </ul>
            </section>

            <div className="mt-8 text-sm text-gray-500">
              <p>Last updated: 3/9/2025</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
